module.exports = __webpack_public_path__ + "img/general-placeholder.b482f574.svg";